// removed by extract-text-webpack-plugin
module.exports = {"date":"_2dBUyLGDfFvRpB6x3pMF2_","intro":"_3fHuhp6sv1UtSpq6WLe8od","photos":"_5_XwxKy44-ryjj8z682UI","instructor":"_2Gdh3yyfjjulbEkvE2Abdq"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/Camps.scss
// module id = 161
// module chunks = 0